const DEFAULT_CAPABILITY = {
  status: 'needs_model',
  label: 'Needs model',
  description: 'No verified local model currently supports this analytic.',
  badgeClass: 'bg-slate-100 text-slate-600 border border-slate-200',
};

export const ANALYTIC_CAPABILITIES = {
  fire_detection: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified fire model exposes a fire class.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  smoke_detection: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified fire model exposes a smoke class.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  ppe_hardhat: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified PPE model exposes Hardhat and NO-Hardhat classes.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  ppe_vest: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified PPE model exposes Safety Vest and NO-Safety Vest classes.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  ppe_glasses: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified PPE model exposes Goggles and NO-Goggles classes.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  ppe_gloves: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified PPE model exposes Gloves and NO-Gloves classes.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  ppe_mask: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified PPE model exposes Mask and NO-Mask classes.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  // harness-best-1.pt is deployed on the engine and passed the class-validation guard
  // ("[OK] Harness model loaded and validated"), so this is now 'supported' — i.e. it
  // appears under Verified Local Models and can be toggled on. Note the detector still
  // ships behind a per-camera shadow gate (Advanced → Harness Detection → Shadow mode),
  // so enabling it here starts logging "[HARNESS-SHADOW] would-alert" without raising
  // any alert until shadow mode is turned off for that camera.
  ppe_harness: {
    status: 'supported',
    label: 'Supported',
    description: 'Verified dedicated harness model exposes harness and no-harness classes.',
    badgeClass: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
  harness_enforcement: {
    status: 'needs_zone',
    label: 'Needs zone',
    description: 'Requires a height work, scaffolding, excavation or confined space zone on this camera, plus the dedicated harness model on the engine.',
    badgeClass: 'bg-blue-50 text-blue-700 border border-blue-200',
  },
  trespassing: {
    status: 'needs_zone',
    label: 'Needs zone',
    description: 'Requires at least one configured zone on this camera.',
    badgeClass: 'bg-blue-50 text-blue-700 border border-blue-200',
  },
  zone_breach: {
    status: 'needs_zone',
    label: 'Needs zone',
    description: 'Requires at least one configured zone on this camera.',
    badgeClass: 'bg-blue-50 text-blue-700 border border-blue-200',
  },
  vehicle_proximity: {
    status: 'experimental',
    label: 'Experimental',
    description: 'Uses person and vehicle detections with estimated distance logic.',
    badgeClass: 'bg-amber-50 text-amber-700 border border-amber-200',
  },
  crowd_detection: {
    status: 'experimental',
    label: 'Experimental',
    description: 'Uses person detections and camera-specific crowd thresholds.',
    badgeClass: 'bg-amber-50 text-amber-700 border border-amber-200',
  },
  fall_detection: {
    status: 'experimental',
    label: 'Experimental',
    description: 'Depends on pose model availability and camera angle.',
    badgeClass: 'bg-amber-50 text-amber-700 border border-amber-200',
  },
};

export const PPE_ITEM_ANALYTIC_IDS = {
  helmet: 'ppe_hardhat',
  vest: 'ppe_vest',
  gloves: 'ppe_gloves',
  boots: 'ppe_boots',
  glasses: 'ppe_glasses',
  mask: 'ppe_mask',
  harness: 'ppe_harness',
  earProtection: 'ppe_ear_protection',
};

export function getAnalyticCapability(id) {
  return ANALYTIC_CAPABILITIES[id] || DEFAULT_CAPABILITY;
}

export function getPpeItemCapability(key) {
  return getAnalyticCapability(PPE_ITEM_ANALYTIC_IDS[key]);
}

export function canEnableCapability(capability) {
  return ['supported', 'needs_zone', 'experimental'].includes(capability.status);
}
